import { EventTriggerFixed } from 'wikr-core-analytics';

import { trackEventFixed } from './mainTrackers';

export const sendAnalyticCabinetStartSession = () => {
    trackEventFixed(EventTriggerFixed.cabinetSessionStarted);
};
